import { configureStore } from "@reduxjs/toolkit";

import { userReducer } from "src/modules/User/store";
import { toasterReducer } from "./toaster";
import { actionsReducer } from "./actions";

export const store = configureStore({
  reducer: {
    actions: actionsReducer,
    user: userReducer,
    toaster: toasterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
